/** Modulo Escola (10) — codigos em contracts/enums.yaml */
export const ESCOLA_ACAO = {
  CRIAR: 101,
  ATUALIZAR: 102,
  REMOVER: 103,
} as const;

export const ESCOLA_ACOES_MODULO = [
  ESCOLA_ACAO.CRIAR,
  ESCOLA_ACAO.ATUALIZAR,
  ESCOLA_ACAO.REMOVER,
] as const;
